import { FullUserBoundary } from '@ui/general';
import { LinkSalesforce } from './LinkSalesforce';
import { LinkSalesforceSandbox } from './LinkSalesforceSandbox';
import { OrganizationsTable } from './OrganizationsTable';
import React from 'react';
import { SETTINGS_ORGANIZATION_COPY } from '@sonar-software/sonar-ts-constants';
import { SonarCard } from '@ui/general/SonarCard';
import { Space } from 'antd';

export const OrganizationsList: React.FC = () =>
	<SonarCard
		extra={
			<FullUserBoundary>
				<Space>
					<LinkSalesforceSandbox key='link-sandbox' />
					<LinkSalesforce key='link-org' />
				</Space>
			</FullUserBoundary>
		}
		id='organizations-list'
		noSpacing
		title={ SETTINGS_ORGANIZATION_COPY.CONNECTED_ORGANIZATIONS }>
		<OrganizationsTable />
	</SonarCard>;

